var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconnotificationexteriorDoorOpenwhite = function SvgIconnotificationexteriorDoorOpenwhite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Notifications/icon.notification.exterior_door_open.white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Notifications/icon.notification.exterior_door_open.white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12",
    stroke: "#D0D0D0",
    points: "5.41935484 20.1290323 5.41935484 2.12903226 16.8387097 2.12903226 16.8387097 20.1290323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    points: "6.30645161 2.60416667 14.4354839 0.75 14.4354839 23 6.30645161 19.7756827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9354839,23.7362163 L14.9354839,0.123112458 L5.80645161,2.20537106 L5.80645161,20.1152568 L14.9354839,23.7362163 Z M13.935,1.376 L13.935,22.264 L6.806,19.435 L6.806,3.002 L13.935,1.376 Z",
    id: "Rectangle",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#4A4A4A",
    transform: "translate(12.546875, 13.262097) scale(-1, 1) translate(-12.546875, -13.262097) ",
    cx: 12.546875,
    cy: 13.2620968,
    rx: 1,
    ry: 1
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconnotificationexteriorDoorOpenwhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.notification.exterior_door_open.white.3e13081a98229800146d263fbb1618b0.svg";